module.exports = __webpack_public_path__ + "static/media/business_info.b0b45bdc.png";